import styled from 'styled-components';
import {
  outlineGray,
  primaryColor,
  primaryColorLight,
  primaryColorStrong,
  primaryColorWeak,
} from '../../../../config/colors';
import { TILE_HEIGHT, MANIFOLD_HEIGHT } from '../consts';

export const Wrapper = styled.div`
  position: absolute;
`;

export const DroppedItem = styled.div`
  z-index: 10;
  outline: 1px solid ${outlineGray};
  overflow: visible;
  :hover {
    cursor: pointer;
  }
  height: ${({isManifold}) => `${isManifold ? MANIFOLD_HEIGHT : TILE_HEIGHT}px !important`};
  translate: 0 -5px;
  background: ${({ bg }) => bg}80;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ padding }) => padding ?? ' 0.375rem'};
  background: ${({ bg }) => bg && `${bg}80`};
  :hover {
    cursor: pointer;
  }
`;

export const SiScore = styled.span`
  font-weight: 600;
  font-size: ${({ fontSize }) => fontSize ?? '0.875rem'};
`;

export const TsCode = styled.span`
  font-weight: 600;
  font-size: ${({ fontSize }) => fontSize ?? '0.75rem'};
`;
